import { useQuery, UseQueryResult, UseQueryOptions } from 'react-query';
import type { ReadUserDto, TagCountDto } from '@goparrot/customer-sdk';

import { userFacade } from '../facades';
import { CUSTOMERS_QUERIES_ENUM } from '../enums';

export const useGetCountByTagList = (merchantId: string, options?: UseQueryOptions<TagCountDto[], ReadUserDto>): UseQueryResult<TagCountDto[], ReadUserDto> => {
  return useQuery([CUSTOMERS_QUERIES_ENUM.TAG_COUNT_LIST, merchantId], () => userFacade.getCountByTags(merchantId), options);
};
